import CardFooter from './CardFooter'

export { CardFooter }
export default CardFooter



// WEBPACK FOOTER //
// ./src/components/CardFooter/index.js